module.exports = __webpack_public_path__ + "img/17312939.a1910f65.png";